import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Popup from 'reactjs-popup';

const ModalModifyAnnuaireAlta = ({ isVisible, onClose, choosenClientAnnuaireAlta, id_client }) => {
    let token = localStorage.getItem("token");
    const [searchPinCode, setSearchPinCode] = useState('');
    const [clients, setClients] = useState([]);
    const [values, setValues] = useState({
        id: '',
        type: '',
        name: '',
        date: '',
        id_anydesk: '',
        password_anydesk: '',
        id_rustdesk: '',
        id_room_pdv: '',
        remarque: '',
        _pin_code: '',
        id_client: id_client
    })

    const handleClose = (e) => { if (e.target.id === "wrapper") onClose(); }
    if (choosenClientAnnuaireAlta.id !== values.id) setValues({ ...values, ...choosenClientAnnuaireAlta })

    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };
    //? Variable Pagination 
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10;
    const lastIndex = currentPage * recordsPerPage;
    const firstindex = lastIndex - recordsPerPage
    const npage = Math.ceil(clients.length / recordsPerPage)
    const numbers = [...Array(npage + 1).keys()].slice(1)

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/InterfaceTizenDevice`)
            .then(res => {
                setClients(res.data)
            }).catch(err => console.log(err))
    }, [])

    const deleteClient = (e) => {
        e.preventDefault();
        let data = {
            id: values.id,
            id_client: values.id_client
        }
        axios.delete(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/delete_device_annuaire_alta`, { headers, data })
            .then((res) => {
                console.log(res);
                window.location.reload(false);
            }).catch(err => console.log(err))

    }
    const handleSubmit = (e) => {
        e.preventDefault();
        values.date = new Date(values.date).toLocaleDateString("fr").split("/").reverse().join("-")


        axios.put(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/update_device_annuaire_alta`, values, { headers })
            .then(res => {
                window.location.reload(false);
            }).catch(err => console.log(err))
    }

    function formatDateClient(datePose) {
        let newdate = new Date(datePose)
        // let month = newdate.getMonth()+1
        let month = newdate.getMonth() + 1 > 9 ? newdate.getMonth() + 1 : `0${newdate.getMonth() + 1}`
        let day = newdate.getDate() > 9 ? newdate.getDate() : `0${newdate.getDate()}`
        let formatDate = `${newdate.getFullYear()}-${month}-${day}`
        return formatDate;
    }

    const close = () => {
        let divTooltip = document.getElementById('popup-2');
        divTooltip.style.display = "none"
    }

    const dropdownVideo = (idDrop,) => (e) => {
        e.preventDefault();
        let element = document.getElementById(idDrop);
        if (element.style.display === "block") {
            element.style.display = "none"
        } else {
            element.style.display = "block"
        }
    }

    const setDevicePinCode = (pinCodeTemp) => (e) => {
        e.preventDefault();
        let element = document.getElementById('dropdownPinCode')
        setValues({ ...values, _pin_code: pinCodeTemp })
        element.style.display = "none"
    }

    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCurrPage(id) {
        setCurrentPage(id)
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }

    if (!isVisible) return null;

    // "Activer la gestion" : déclenche le provisionnement à distance (publie "provision"
    // sur le topic MQTT = pincode -> signage bootstrappe le provisioner).
    const handleProvision = () => {
        if (!values._pin_code) { alert('Pincode manquant sur ce device.'); return; }
        axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/provision_device`, { _pin_code: values._pin_code }, { headers })
            .then(() => alert('Commande de provisionnement envoyée au device (' + values._pin_code + ').'))
            .catch((e) => alert("Échec de l'envoi : " + (e?.response?.data?.error || e.message)));
    };

    // Statut TÉLÉMAINTENANCE : dérivé des ID remontés (RustDesk/AnyDesk) + fraîcheur du
    // provisionnement (provisioned_at, rempli par l'app provisioner via /record_provisioning).
    const _prov = values.provisioned_at ? new Date(String(values.provisioned_at).replace(/\//g, '-')) : null;
    const _provDays = _prov && !isNaN(_prov.getTime()) ? Math.floor((Date.now() - _prov.getTime()) / 86400000) : null;
    const _hasRd = !!(values.id_rustdesk && String(values.id_rustdesk).trim());
    const _hasAd = !!(values.id_anydesk && String(values.id_anydesk).trim());
    let telemColor = 'bg-red-500', telemLabel = 'Non géré';
    if (_hasRd && _hasAd && _provDays !== null && _provDays <= 30) { telemColor = 'bg-emerald-500'; telemLabel = 'Géré'; }
    else if (_hasRd || _hasAd || _provDays !== null) { telemColor = 'bg-amber-500'; telemLabel = 'Partiel'; }

    return (
        <div className='fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex justify-center items-center' id="wrapper" onClick={handleClose}>
            <div className='w-2/3 flex flex-col'>
                <button className='text-white text-xl place-self-end' onClick={() => onClose()}>X</button>
                <div className='w-full'>
                    <div className="flex items-center gap-3 mb-3">
                        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-white text-xs font-semibold ${telemColor}`}>
                            <span className="h-2 w-2 rounded-full bg-white/80"></span>
                            Télémaintenance : {telemLabel}
                        </span>
                        {_provDays !== null && (
                            <span className="text-slate-300 text-xs">
                                dernière remontée {_provDays === 0 ? "aujourd'hui" : `il y a ${_provDays} j`}
                            </span>
                        )}
                        <button type="button" onClick={handleProvision}
                            className="ml-auto inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white text-xs font-semibold">
                            ⚙ Activer la gestion
                        </button>
                    </div>
                    <div id="dropdownPinCode" class="z-40 hidden absolute top-8 bg-white divide-y rounded-lg shadow w-2/3 h-3/4 dark:bg-slate-700 cursor-pointer overflow-auto">
                        <div className="relative flex items-center left-1/4 w-2/4 h-9 rounded-lg focus-within:shadow-lg bg-slate-700 overflow-hidden my-2">
                            <div className="grid place-items-center h-full w-12 text-slate-50">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </div>

                            <input
                                className="h-full w-full outline-none text-white pr-2 bg-slate-700 placeholder-slate-50"
                                type="text"
                                id="search"
                                placeholder="Search something.."
                                onChange={(e) => { setSearchPinCode(e.target.value); setCurrentPage(1) }}
                            />
                        </div>
                        <table class="w-full text-sm text-left text-slate-500 dark:text-slate-400">
                            <thead class="text-xs text-slate-700 uppercase bg-slate-50 dark:bg-slate-700 dark:text-slate-400">
                                <tr>
                                    <th scope="col" class="px-6 py-3">
                                        Nom Client
                                    </th>
                                    <th scope="col" class="px-6 py-3">
                                        Pin Code
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {


                                    clients.filter((item) => {
                                        return searchPinCode.toLowerCase() === ''
                                            ? item
                                            : item._client_name.toLowerCase().includes(searchPinCode.toLowerCase()) || item._pin_code.toLowerCase().includes(searchPinCode.toLowerCase())
                                    }).slice(firstindex, lastIndex).map((client, i) => (
                                        <tr class="bg-white border-b dark:bg-slate-800 dark:border-slate-700" key={i} onClick={setDevicePinCode(client._pin_code)} >
                                            {/* <tr class="bg-white border-b dark:bg-slate-800 dark:border-slate-700" key={i} > */}
                                            <th scope="row" class="px-6 py-4 font-medium text-slate-900 whitespace-nowrap dark:text-white">
                                                {client._client_name}
                                            </th>
                                            <td class="px-6 py-4">
                                                {client._pin_code}
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation example" className='absolute bottom-4 right-2/1'>
                            <ul className="inline-flex -space-x-px text-sm">
                                <li>
                                    <a className="flex items-center justify-center px-3 h-8 ml-0 leading-tight text-slate-500 bg-white border border-slate-300 rounded-l-lg hover:bg-slate-100 hover:text-slate-700 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-700 dark:hover:text-white" onClick={prePage} >Previous</a>
                                </li>

                                {numbers.map((n, i) => {
                                    return <li>
                                        <a className="flex items-center justify-center px-3 h-8 leading-tight text-slate-500 bg-white border border-slate-300 hover:bg-slate-100 hover:text-slate-700 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-700 dark:hover:text-white" onClick={() => changeCurrPage(n)}>{n}</a>
                                    </li>
                                })}

                                <li>
                                    <a className="flex items-center justify-center px-3 h-8 leading-tight text-slate-500 bg-white border border-slate-300 rounded-r-lg hover:bg-slate-100 hover:text-slate-700 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-700 dark:hover:text-white" onClick={nextPage} >Next</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <form className="bg-slate-700 p-6 rounded-3xl" onSubmit={handleSubmit}>
                        <div className="relative z-0 w-full mb-6 group">
                            <label htmlFor="type" className="block mb-2 text-sm  text-slate-50 dark:text-white">Type</label>
                            <select id="type" className="bg-slate-50 border border-slate-300 text-slate-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-slate-700 dark:border-slate-600 dark:placeholder-slate-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={e => setValues({ ...values, type: e.target.value })} defaultValue={values.type}>
                                <option value="" disabled hidden>Choisissez le type</option>
                                <option value="xiaomiStick" >Xiaomi Stick</option>
                                <option value="khadasStick">Khadas Stick</option>
                                <option value="khadas4k">Khadas 4K</option>
                                <option value="electron">Electron</option>
                            </select>
                        </div>
                        <div className="relative z-0 w-full mb-6 group">
                            <input type="text" name="name" id="name" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-slate-50 appearance-none dark:text-white dark:border-slate-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " onChange={e => setValues({ ...values, name: e.target.value })} value={values.name} />
                            <label htmlFor="name" className="peer-focus:font-medium absolute text-sm text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Nom:</label>
                        </div>
                        <div className="relative z-0 w-full mb-6 group">
                            <input type="date" name="date" id="date" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-slate-50 appearance-none dark:text-white dark:border-slate-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " onChange={e => setValues({ ...values, date: e.target.value })} value={formatDateClient(values.date)} />
                            <label htmlFor="date" className="peer-focus:font-medium absolute text-sm text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Date:</label>
                        </div>
                        <div className="relative z-0 w-full mb-6 group">
                            <input type="text" name="id_anydesk" id="id_anydesk" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-slate-50 appearance-none dark:text-white dark:border-slate-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " onChange={e => setValues({ ...values, id_anydesk: e.target.value })} value={values.id_anydesk} />
                            <label htmlFor="id_anydesk" className="peer-focus:font-medium absolute text-sm text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Anydesk ID:</label>
                        </div>
                        <div className="relative z-0 w-full mb-6 group">
                            <input type="text" name="password_anydesk" id="password_anydesk" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-slate-50 appearance-none dark:text-white dark:border-slate-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " onChange={e => setValues({ ...values, password_anydesk: e.target.value })} value={values.password_anydesk} />
                            <label htmlFor="password_anydesk" className="peer-focus:font-medium absolute text-sm text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Anydesk Password:</label>
                        </div>
                        <div className="relative z-0 w-full mb-6 group">
                            <input type="text" name="id_rustdesk" id="id_rustdesk" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-slate-50 appearance-none dark:text-white dark:border-slate-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " onChange={e => setValues({ ...values, id_rustdesk: e.target.value })} value={values.id_rustdesk} />
                            <label htmlFor="id_rustdesk" className="peer-focus:font-medium absolute text-sm text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">RustDesk ID:</label>
                        </div>
                        <div className="relative z-0 w-full mb-6 group">
                            <input type="text" name="id_room_pdv" id="id_room_pdv" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-slate-50 appearance-none dark:text-white dark:border-slate-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " onChange={e => setValues({ ...values, id_room_pdv: e.target.value })} value={values.id_room_pdv} />
                            <label htmlFor="id_room_pdv" className="peer-focus:font-medium absolute text-sm text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Room ID / ID PDV:</label>
                        </div>
                        <div className="relative z-0 w-full mb-6 group">
                            <textarea name="remarque" id="remarque" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-slate-50 appearance-none dark:text-white dark:border-slate-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " onChange={e => setValues({ ...values, remarque: e.target.value })} value={values.remarque} />
                            <label htmlFor="remarque" className="peer-focus:font-medium absolute text-sm text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Remarque:</label>
                        </div>
                        <div className="relative z-0 w-full mb-6 group">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 right-1 absolute cursor-pointer" onClick={dropdownVideo('dropdownPinCode')} >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                            </svg>
                            <input type="text" name="_pin_code" id="_pin_code" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-slate-50 appearance-none dark:text-white dark:border-slate-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " onChange={e => setValues({ ...values, _pin_code: e.target.value })} value={values._pin_code} />
                            <label htmlFor="_pin_code" className="peer-focus:font-medium absolute text-base text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Pin Code:</label>
                        </div>
                        <div className='flex justify-between'>
                            <Popup trigger=
                                {<button type="button" className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-blue-800" > Supprimer </button>}
                                position="right center">
                                <div>Est-ce votre dernier mot?</div>
                                <div className="flex justify-between">
                                    <button type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-2 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" onClick={deleteClient}> Accepter </button>
                                    <button type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-2 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" onClick={close}> Annuler </button>
                                </div>
                            </Popup>
                            <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ModalModifyAnnuaireAlta;